<div class="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
  <div class="w-full" [class.max-w-lg]="step() === 'details'" [class.max-w-4xl]="step() === 'plan'">

    <!-- Header -->
    <div class="text-center mb-8">
      <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-500/20 border border-blue-500/30 mb-4">
        <svg class="w-8 h-8 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-5.13a4 4 0 11-8 0 4 4 0 018 0zm6 0a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      </div>
      <h1 class="text-2xl font-bold text-white">Create Your First Committee</h1>
      <p class="text-slate-400 mt-2 text-sm">
        @if (step() === 'details') {
          Add the first committee under this village. You can edit advanced settings later.
        } @else {
          Pick a plan for this committee. You can change it later from the billing page.
        }
      </p>

      <!-- Step indicator -->
      <div class="mt-5 flex items-center justify-center gap-2">
        <span class="px-2.5 py-0.5 rounded-full text-xs font-medium"
              [ngClass]="step() === 'details' ? 'bg-blue-500/20 text-blue-300 border border-blue-500/30' : 'bg-slate-700/50 text-slate-400'">
          1. Details
        </span>
        <span class="w-6 h-px bg-slate-600"></span>
        <span class="px-2.5 py-0.5 rounded-full text-xs font-medium"
              [ngClass]="step() === 'plan' ? 'bg-blue-500/20 text-blue-300 border border-blue-500/30' : 'bg-slate-700/50 text-slate-400'">
          2. Plan
        </span>
      </div>
    </div>

    <!-- Card -->
    <div class="bg-slate-800/60 backdrop-blur border border-slate-700/50 rounded-2xl p-8 shadow-2xl">

      <!-- ============================================================ -->
      <!-- Step 1: Details                                              -->
      <!-- ============================================================ -->
      @if (step() === 'details') {
        <form [formGroup]="form" (ngSubmit)="goToPlanStep()" novalidate>

          <div class="mb-5">
            <label class="block text-sm font-medium text-slate-300 mb-2">Committee Name <span class="text-red-400">*</span></label>
            <input
              type="text"
              formControlName="name"
              placeholder="e.g. Temple Committee"
              class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
              [class.border-red-500]="f['name'].invalid && f['name'].touched"
            />
            @if (f['name'].invalid && f['name'].touched) {
              <p class="text-red-400 text-xs mt-1">Name is required (min. 2 characters).</p>
            }
          </div>

          <div class="mb-5">
            <label class="block text-sm font-medium text-slate-300 mb-2">Short Code <span class="text-slate-500 text-xs">(optional, auto-generated)</span></label>
            <input
              type="text"
              formControlName="code"
              placeholder="e.g. TEMPLE"
              class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
            />
          </div>

          <div class="mb-5">
            <label class="block text-sm font-medium text-slate-300 mb-2">Description</label>
            <textarea
              formControlName="description"
              rows="2"
              placeholder="Brief description of the committee"
              class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors resize-none"
            ></textarea>
          </div>

          <div class="mb-5">
            <label class="block text-sm font-medium text-slate-300 mb-2">Contact Email</label>
            <input
              type="email"
              formControlName="contactEmail"
              placeholder="e.g. committee@village.lk"
              class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
              [class.border-red-500]="f['contactEmail'].invalid && f['contactEmail'].touched"
            />
            @if (f['contactEmail'].invalid && f['contactEmail'].touched) {
              <p class="text-red-400 text-xs mt-1">Please enter a valid email address.</p>
            }
          </div>

          <div class="mb-5">
            <label class="block text-sm font-medium text-slate-300 mb-2">Contact Phone</label>
            <input
              type="tel"
              formControlName="contactPhone"
              placeholder="e.g. 0112 345 678"
              class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
            />
          </div>

          <div class="mb-5">
            <label class="block text-sm font-medium text-slate-300 mb-2">Chairman</label>
            <input
              type="text"
              formControlName="chairman"
              placeholder="Name of the chairman"
              class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
            />
          </div>

          <div class="mb-6">
            <label class="block text-sm font-medium text-slate-300 mb-2">Secretary</label>
            <input
              type="text"
              formControlName="secretary"
              placeholder="Name of the secretary"
              class="w-full px-4 py-3 rounded-xl bg-slate-700/50 border border-slate-600/50 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500/70 focus:ring-1 focus:ring-blue-500/30 transition-colors"
            />
          </div>

          @if (errorMessage) {
            <div class="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 text-sm">
              {{ errorMessage }}
            </div>
          }

          <button
            type="submit"
            class="w-full py-3 px-4 rounded-xl font-semibold text-white bg-blue-600 hover:bg-blue-500 transition-colors"
          >
            Continue to plan →
          </button>
        </form>
      }

      <!-- ============================================================ -->
      <!-- Step 2: Plan                                                 -->
      <!-- ============================================================ -->
      @if (step() === 'plan') {

        <!-- Billing cycle toggle -->
        <div class="flex items-center justify-center mb-6">
          <div class="inline-flex p-1 rounded-xl bg-slate-700/50 border border-slate-600/50">
            <button type="button" (click)="setCycle('Monthly')"
                    class="px-4 py-2 text-sm font-medium rounded-lg transition-colors"
                    [ngClass]="selectedCycle() === 'Monthly' ? 'bg-blue-600 text-white' : 'text-slate-300 hover:text-white'">
              Monthly
            </button>
            <button type="button" (click)="setCycle('Annual')"
                    class="px-4 py-2 text-sm font-medium rounded-lg transition-colors"
                    [ngClass]="selectedCycle() === 'Annual' ? 'bg-blue-600 text-white' : 'text-slate-300 hover:text-white'">
              Annual <span class="text-xs ml-1 opacity-80">(save ~2 months)</span>
            </button>
          </div>
        </div>

        @if (isLoadingPlans()) {
          <div class="text-center py-8 text-slate-400 text-sm">Loading plans…</div>
        } @else if (plans().length === 0) {
          <div class="text-center py-8 text-slate-400 text-sm">
            No plans are available. You can continue without a subscription and pick one later from the billing page.
          </div>
        } @else {
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
            @for (plan of plans(); track plan.id) {
              <button type="button"
                      (click)="selectPlan(plan.id)"
                      class="text-left rounded-xl border-2 p-4 transition-colors"
                      [ngClass]="selectedPlanId() === plan.id
                        ? 'border-blue-500 bg-blue-500/10'
                        : 'border-slate-600/50 bg-slate-700/30 hover:border-slate-500'">
                <div class="flex items-start justify-between gap-3">
                  <div>
                    <div class="flex items-center gap-2">
                      <h3 class="text-base font-semibold text-white">{{ plan.name }}</h3>
                      <span class="text-xs font-mono px-1.5 py-0.5 rounded bg-slate-800 text-slate-400">{{ plan.code }}</span>
                    </div>
                    @if (plan.description) {
                      <p class="text-xs text-slate-400 mt-1 line-clamp-2">{{ plan.description }}</p>
                    }
                  </div>
                  @if (selectedPlanId() === plan.id) {
                    <span class="text-blue-400 text-sm">✓</span>
                  }
                </div>

                <div class="mt-3 flex items-baseline gap-1">
                  @if (isFreePlan(plan)) {
                    <span class="text-2xl font-bold text-white">Free</span>
                  } @else {
                    <span class="text-2xl font-bold text-white">Rs. {{ priceFor(plan) | number:'1.0-0' }}</span>
                    <span class="text-xs text-slate-400">/ {{ selectedCycle() === 'Annual' ? 'year' : 'month' }}</span>
                  }
                </div>

                <ul class="mt-3 text-xs text-slate-300 space-y-1">
                  <li>Members: <strong>{{ plan.entitlements.maxMembers ?? '∞' }}</strong></li>
                  <li>Active events: <strong>{{ plan.entitlements.maxActiveEvents ?? '∞' }}</strong></li>
                  <li>Users / BU: <strong>{{ plan.entitlements.maxUsersPerBu ?? '∞' }}</strong></li>
                  @if (plan.trialDays > 0 && !isFreePlan(plan)) {
                    <li class="text-blue-300">{{ plan.trialDays }}-day trial available</li>
                  }
                </ul>
              </button>
            }
          </div>

          <!-- Trial toggle (only meaningful for paid plans with trialDays > 0) -->
          <label class="flex items-center gap-2 text-sm text-slate-300 mb-6 cursor-pointer">
            <input type="checkbox" [checked]="startTrial()" (change)="toggleTrial()"
                   class="w-4 h-4 rounded border-slate-500 bg-slate-700 text-blue-600 focus:ring-blue-500/30">
            Start with a trial if the selected plan offers one
          </label>
        }

        @if (errorMessage) {
          <div class="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 text-sm">
            {{ errorMessage }}
          </div>
        }

        <div class="flex items-center gap-2">
          <button type="button"
                  (click)="backToDetails()"
                  [disabled]="isSubmitting"
                  class="px-4 py-3 rounded-xl text-sm font-medium border border-slate-600 text-slate-300 hover:bg-slate-700/50 disabled:opacity-50">
            ← Back
          </button>
          <button type="button"
                  (click)="onSubmit()"
                  [disabled]="isSubmitting || (!selectedPlanId() && plans().length > 0)"
                  class="flex-1 py-3 px-4 rounded-xl font-semibold text-white bg-blue-600 hover:bg-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            @if (isSubmitting) {
              <span class="inline-flex items-center gap-2">
                <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                </svg>
                Creating committee…
              </span>
            } @else {
              Create committee
            }
          </button>
        </div>
      }

    </div>

  </div>
</div>
